<template>
	<PageTemplate>
		<template #h1> Music </template>
		<div class="monospaced">
			<p>
				Some snippets from my compositions. Scores and full demos
				available upon request.
			</p>

			<h2>Compositions</h2>
			<h3>Jazz</h3>
			<Track title="Inominate Chaos">
				<p>Big Band piece, performed by the Vincent D'Indy Big Band.</p>

				<iframe
					width="560"
					height="315"
					src="https://www.youtube-nocookie.com/embed/ZAFTBuPjxLg?si=Im9VFxLtoxMDioIH"
					title="YouTube video player"
					frameborder="0"
					allow="
						accelerometer;
						autoplay;
						clipboard-write;
						encrypted-media;
						gyroscope;
						picture-in-picture;
						web-share;
					"
					referrerpolicy="strict-origin-when-cross-origin"
					allowfullscreen
				></iframe>
			</Track>

			<h3>The Game I Never Got To Make</h3>

			<Track
				title="Scarlet"
				src="/assets/audio/09_shadowlerone_Scarlet.mp3"
			>
				Scarlet is a changeling Rogue. This composition is their
				character theme. Written in the context of a composition class,
				this piece weaves the different parts of Scarlet's complex
				identity, their struggle with their sense of self. Despite her
				not being a main character in The Game, her growth would have
				been on of the main plot-threads. The music is supposed to grow
				with her.
			</Track>
			<Track
				title="Royal Festival Theme"
				src="/assets/audio/03_shadowlerone_Royal Festival Theme.mp3"
			>
			</Track>
			<Track
				title="Battle! Royal Guard"
				src="/assets/audio/04_shadowlerone_Battle! Royal Guard.mp3"
			>
				A simple battle theme for when the party is fighting the Royal
				Guard. This was an exercise in using the main motif from the
				Royal Festival theme.
			</Track>

			<Trackset
				title="Adrian Vince Suite"
				:src="[
					'/assets/audio/06_shadowlerone_Adrian Vince.mp3',
					'/assets/audio/07_shadowlerone_Adrian Vince Battle.mp3',
					'/assets/audio/08_shadowlerone_Aftermath.mp3',
				]"
			>
				Adrian Vince is the main antagonist of The Game I Never Got To
				Make. He is a mafia boss with a interest in wizardry and
				alchemy. He hires young talents from various universities to do
				research for him, findings he then sells off to the highest
				bidder on the black market. This piece is in three movements:
				first, his character theme; then, the battle theme; and finally,
				the post battle music. Each were written to evoke a certain
				sense of dread and anticipation, while also providing catharsis
				for the heroes at various points in their relationship with the
				villain.
			</Trackset>
		</div>
	</PageTemplate>
</template>
<script setup>
import Track from "@/components/music/Track.vue";
import Trackset from "@/components/music/Trackset.vue";
import PageTemplate from "./PageTemplate.vue";
</script>
